import { type ErrorEvent } from '@sentry/vue'

// Some keywords that typically appear in the url when an import
// error takes place in legacy
const urlLegacyKeywords = [
  'clubes',
  'politica-privacidad',
  'zonaclub',
]

/**
 * Ignore all errors whose URL contains some legacy keyword
 */
export function filterLegacyUrlErrors(error: ErrorEvent) {
  const url = error.request?.url
  if (!url) return true
  return !urlLegacyKeywords.some((keyword) => url.includes(keyword))
}
